import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import {
  FaEnvelope,
  FaFacebook,
  FaGlobe,
  FaInstagram,
  FaInstagramSquare,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaPinterest,
  FaTwitter,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { AiFillFacebook } from "react-icons/ai";
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import { TiLocationOutline } from "react-icons/ti";
import { FaSquareXTwitter } from "react-icons/fa6";
import Banner from "../Pricing/Banner";
import { ContactUsapi, GetSettingData } from "../../../utils/API";
import { Link } from "react-router-dom";
import contactus from "../../../assets/frontendassets/About us/contactus.jpg";

function ContactUs() {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [settings, setSettings] = useState<any>({});
  
  const handleSubmit = async (values: any) => {
 
    setIsSubmitting(true); // Start loading
    try {
      const response = await ContactUsapi(values);
    
      if (response && response.data && response.data.message) {
        message.success(response.data.message);
        form.resetFields();
      } else {
        message.error("Email already exists., please use different email.");
      }
    } catch (error) {
     
      message.error("Email already exists., please use different email.");
    } finally {
      setIsSubmitting(false); // Stop loading
    }
  };


  
    const fetchSettingsData = async () => {
      try {
        const response = await GetSettingData();
        setSettings(response.settings[0]);
      } catch (error) {
        console.error('Failed to fetch settings data:', error);
      }
    };
  
    useEffect(() => {
      fetchSettingsData();
    }, []);

  return (
    <>
   <div className="bg-[#FFF8EC]"> 
<div className="justify-center items-center flex pt-4 flex-col px-4 sm:px-8">
  <h1 className="text-[24px] mb-4 text-center sm:text-[28px]">Got Questions?</h1>
  <h1 className="text-[30px] mb-4 text-center sm:text-[32px]">
    Request a call back now and get expert guidance in no time!
  </h1>
  <a href="tel:9319270033">
  <button
    type="button"
    className="bg-[#F9B138] h-12 rounded-2xl px-4 text-[20px] text-black w-[300px] whitespace-nowrap flex items-center justify-center"
  >
    Request Call Back
  </button>
</a>

</div>

<div className="mt-3 sm:mt-5 xs:p-3 xxs:p-3 sm:p-12">
  {/* Header Section */}
  <div className="flex items-center justify-start">
    <hr className="w-[130px] h-[2px] text-black" />
    <h1 className="lg:text-[20px] md:text-[15px] font-normal flex items-center ml-3">CONTACT US</h1>
  </div>

  {/* Main Section with Two Columns */}
  <div className="flex flex-col sm:flex-row gap-8 sm:gap-20 mt-2">
    {/* Left Column */}
    <div className="w-full sm:w-1/2 space-y-3">
      <h1 className="lg:text-[30px] md:text-[25px]  font-normal">Get in touch with us !</h1>
      <p className="lg:text-[20px] md:text-[15px] leading-7">
        Reach out for expert support and personalized <br /> solutions.
        We're here to help your business grow!
      </p>

      {/* Contact Details */}
    <div className="flex flex-col md:flex-row md:space-x-6">
  {/* Contact Information */}
  <div className="md:w-1/2 ">
    <div className="lg:pt-3 lg:pb-3 md:pb-2 xs:py-2 xxs:py-2 flex items-center">
      <IoCallOutline  className="lg:text-[25px] md:text-[15px] text-[#E6AC53] mr-2" />
      <h1 className="lg:text-[25px] md:text-[15px] font-semibold">Call Us:</h1>
    </div>
    <p className="ml-[23px]  lg:text-[20px] md:text-[15px]">+91{settings ? settings.phone : "9319270033"}</p>

    <div className="lg:pt-3 lg:pb-3 md:pb-2 xs:py-2 xxs:py-2 flex items-center">
      <FaGlobe  className="lg:text-[25px] md:text-[15px] text-[#E6AC53] mr-2"  />
      <h1 className="lg:text-[25px] md:text-[15px]  font-semibold">Website:</h1>
    </div>
    <p className="ml-[23px] lg:text-[20px] md:text-[15px]">www.net4surge.com</p>
  </div>

  {/* Email and Address */}
  <div className="md:w-1/2 ">
    <div className="lg:pt-3 lg:pb-3 md:pb-2 xs:py-2 xxs:py-2 flex items-center">
      <MdOutlineEmail  className="lg:text-[25px] md:text-[15px] text-[#E6AC53] mr-2"   />
      <h1 className="lg:text-[25px] md:text-[15px]  font-semibold">Email us:</h1>
    </div>
    <p className="ml-[23px] lg:text-[20px] md:text-[15px]">info@net4surge.com</p>

    <div className="lg:pt-3 lg:pb-3 md:pb-2 xs:py-2 xxs:py-2 flex items-center">
      <TiLocationOutline  className="lg:text-[25px] md:text-[15px] text-[#E6AC53] mr-2"  />
      <h1 className="lg:text-[25px] md:text-[15px]  font-semibold">Address:</h1>
    </div>
    <p className="ml-[23px] lg:text-[20px] md:text-[15px] leading-6">
      D, 9, Vyapar Marg, Block D, <br />
      Noida Sector 3, Noida, Uttar <br />
      Pradesh 201301
    </p>
  </div>
</div>


      <h1 className="lg:text-[25px] md:text-[15px]  font-semibold mt-4 ml-[23px] ">Follow us on:</h1>
      <div className="flex gap-3 mt-2  ml-[23px] ">
            <Link to={"https://www.instagram.com/net4surge"} target="_blank" >
            <FaInstagram
                  size={35}

                  className="text-white p-[2px] mt-[2px] cursor-pointer"
                  style={{
                    backgroundImage: "linear-gradient(to top right, #feda75, #fa7e1e, #d6249f)",
                    borderRadius : "22%",
                  }} />
            </Link>
            <Link to={"https://www.facebook.com/net4surge"} target="_blank">
            <AiFillFacebook size={40} className="text-blue-500 cursor-pointer" /></Link>
            <Link to={"https://x.com/net4surge"} target="_blank">
            <FaSquareXTwitter size={40} className="bg-white cursor-pointer text-black" /></Link>
            <Link to={"https://www.linkedin.com/in/net4surge"} target="_blank">
            <FaLinkedin size={40} className="text-blue-600 cursor-pointer" /></Link>
          </div>
    </div>
   
    {/* Right Column: Contact Form */}
    
<div className="w-full sm:w-1/2 mb-10 bg-[#FFF8EC]">
     
       <Form
  layout="vertical"
  form={form}
  onFinish={handleSubmit}
  requiredMark="optional"
  className="space-y-8"
>
  <Form.Item
    name="name"
    rules={[{ required: true, message: "Please enter your name" }]}
    className="relative w-full"
  >
    <div className="relative">
      <label
        htmlFor="name"
        className="absolute -top-4 z-1 left-10  px-2 text-[20px] text-black bg-[#fff8ec]"
      >
        Your Name
      </label>
      <Input
        id="name"
        placeholder="Enter your name"
        className="w-full p-3 border border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#fff8ec]"
      />
    </div>
  </Form.Item>

  <Form.Item
    name="email"
    rules={[
      { required: true, message: "Please enter your email" },
      { type: "email", message: "Please enter a valid email" },
    ]}
    className="relative w-full"
  >
    <div className="relative">
      <label
        htmlFor="email"
        className="absolute -top-4 z-1 left-10  px-2 text-[20px] text-black bg-[#fff8ec]"
      >
        Email Id
      </label>
      <Input
        id="email"
        placeholder="Enter your email"
        className="w-full p-3 border border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#fff8ec]"
      />
    </div>
  </Form.Item>

  <Form.Item
    name="phone"
    rules={[
      { required: true, message: "Please enter your mobile number" },
      {
        pattern: /^\d{10}$/,
        message: "Please enter a valid 10-digit number",
      },
    ]}
    className="relative w-full"
  >
    <div className="relative">
      <label
        htmlFor="mobile"
        className="absolute -top-4 z-1 left-10 bg-[#fff8ec] px-2 text-[20px] text-black"
      >
        Mobile No
      </label>
      <Input
        id="mobile"
        placeholder="Enter your mobile number"
        className="w-full p-3 border border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#fff8ec] "
        onKeyPress={(e) => {
          if (!/^\d$/.test(e.key)) {
            e.preventDefault(); // Prevent non-numeric characters
          }
        }}
      />
    </div>
  </Form.Item>

  <Form.Item
    name="message"
    rules={[{ required: true, message: "Please enter your message" }]}
    className="relative w-full"
  >
    <div className="relative">
      <label
        htmlFor="message"
        className="absolute -top-4 z-1 left-10 bg-[#fff8ec] px-2 text-[20px] text-black"
      >
        Your Message
      </label>
      <Input.TextArea
        id="message"
        placeholder="Enter your message"
        rows={4}
        className="w-full p-3 border border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#fff8ec]"
      />
    </div>
  </Form.Item>

  <Form.Item>
    {/* Submit Button <Button
      type="primary"
      htmlType="submit"
      className="bg-[#F7D278] h-12 rounded-2xl px-4 text-[20px] text-black w-[220px]  whitespace-nowrap flex items-center justify-center"
    >
      Send Message
    </Button> */}
  <div className="flex justify-start  sm:justify-start">
  <Button
                      type="primary"
                      htmlType="submit"
                      className="bg-[#F7D278] h-12 rounded-2xl px-4 text-[20px] text-black w-[220px] whitespace-nowrap flex items-center justify-center"
                      style={{
                        backgroundColor: "#F9B138",
                        color: "black",
                        border: "none",
                        boxShadow: "none",
                      }}
                      loading={isSubmitting} // Add loading state here
                    >
                      {isSubmitting ? "Submitting..." : "Send Message"}
                    </Button>

</div>

  </Form.Item>
</Form>

    </div>

  </div>
</div>

<section id="contact-us">
  <div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1755.7431801679925!2d77.31922!3d28.583507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce459b9eee365%3A0xc10324364915d53!2sBlock%20D%2C%209%2C%20Vyapar%20Marg%2C%20Block%20D%2C%20Noida%20Sector%203%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1698334770840!5m2!1sen!2sin"
      width="100%"
      height="500"
      loading="lazy"
    ></iframe>
  </div>
</section>
</div>
    </>
  );
}

export default ContactUs;
